import React, {useEffect, useState} from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Input, Button, Tooltip, DialogHeader, DialogBody, DialogFooter, Dialog,

} from "@material-tailwind/react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";

export default function ForgetPasswordForm() {
    const [email, setEmail] = useState("");
    const [verifyError, setVerifyError] = useState(false);
    const [openEmailVerificationDialog, setOpenEmailVerificationDialog] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleResetPasswordSubmit = async (e) => {
        e.preventDefault();

        const API_URL = process.env.REACT_APP_API_URL;

        try {
            const response = await axios.post(`${API_URL}/auth/request_password_reset`, { email });

            setOpenEmailVerificationDialog(true);  // Otvori dijalog nakon uspešnog slanja zahteva.

            // Zatvori dijalog nakon 5 sekundi (trajanje prikaza dijaloga)
            setTimeout(() => {
                setOpenEmailVerificationDialog(false);
                // Opcionalno, preusmeri korisnika na drugu stranicu nakon 5 sekundi
                if (location.state && location.state.from) {
                    navigate(location.state.from);
                } else {
                    navigate("/login");  // Preusmeri na login stranicu
                }
            }, 5500);
        } catch (err) {
            setVerifyError(true);
        }
    };

    useEffect(() => {
        setVerifyError(false);
    }, [email]);

    const handleOpenEmailVerificationDialog = () => {
        setOpenEmailVerificationDialog(!openEmailVerificationDialog);
    };

    const TooltipVerifyError = () => {
        return (
            <div className="p-1">
                <p className=" text-red-500 font-bold">Neispravan email</p>
            </div>
        );
    };

    function storeScrollPosition() {
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    }

    return (
        <>
            <Card className="w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl">
                <CardHeader
                    color="gray"
                    floated={false}
                    style={{
                        backgroundImage:
                            'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 3)), url("/images/login-page/naslovna2.JPEG")',
                        backgroundBlendMode: 'multiply',
                    }}
                    className="m-0 grid place-items-center rounded-b-none py-8 px-4 bg-contain bg-center text-center"
                >
                    <div className="mt-4 mb-4 rounded-full border-4 border-white/30 bg-white/20 p-3 text-white">
                        <img
                            src="/transparent logo solo.png"
                            alt="Logo"
                            className="h-20 w-20"
                        />
                    </div>
                    <Typography variant="h4" color="white" className="font-semibold">
                        Smart Service System
                    </Typography>
                    <Typography variant="h6" color="white" className="mt-1">
                        - Vaša energija, naša briga -
                    </Typography>
                </CardHeader>

                <CardBody className="bg-white px-6 py-4 rounded-2xl">
                    <div className="flow-root">
                        <div className="flex flex-col items-center justify-center w-full px-6 py-4 sm:px-8 sm:py-6">
                            <Typography variant="h4" color="blue-gray" className="text-center mb-4 font-semibold">
                                Resetovanje lozinke
                            </Typography>

                            <form className="mt-6 mb-2 w-full sm:max-w-md" onSubmit={handleResetPasswordSubmit}>
                                <div className="mb-4 flex flex-col gap-6">
                                    <Input
                                        color="blue"
                                        size="lg"
                                        label="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        error={verifyError}
                                        className="rounded-lg border-2"
                                    />
                                </div>

                                {/* Error message */}
                                {verifyError && (
                                    <div className="flex items-center justify-center mt-4">
                                        <Typography className="text-red-500 mr-2">Ups! Doslo je do greske</Typography>
                                        <Tooltip content={<TooltipVerifyError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                            <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                                        </Tooltip>
                                    </div>
                                )}

                                {/* Reset Password Button */}
                                <Button
                                    color="green"
                                    className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-12 sm:mt-16"
                                    fullWidth
                                    type="submit"
                                    onClick={storeScrollPosition}
                                >
                                    Resetuj lozinku
                                </Button>

                                <Typography color="gray" className="mt-4 text-center font-normal">
                                    Email sa upustvima ce stici u roku od 5 minuta.<br/>
                                </Typography>
                            </form>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Dialog open={openEmailVerificationDialog} handler={handleOpenEmailVerificationDialog}>
                <DialogHeader>Uspešno ste zatražili resetovanje lozinke</DialogHeader>
                <DialogBody>
                    <p className="mt-2">
                        Zahtev za resetovanje lozinke je validan 15 minuta. Email sa uputstvima će biti poslat u roku od 5 minuta.
                    </p>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="gradient"
                        color="blue"
                        onClick={handleOpenEmailVerificationDialog}
                    >
                        U redu
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    );
}